import { createBrowserRouter } from "react-router-dom";
import Home from './Componets/Home/Home';
import About from './Componets/About/About';
import Portfolio from './Componets/Portfolio/Portfolio';
import Contact from './Componets/Contact/Contact';
import Details from "./Componets/Portfolio/Details/Details";
import MyBlog from "./Componets/MyBlog/MyBlog";

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home></Home>
  },
  {
    path: '/home',
    element: <Home></Home>
  },
  {
    path: '/about',
    loader: () => fetch('aboutInfo.json'),
    element: <About></About>
  },
  {
    path: '/portfolio',
    element: <Portfolio></Portfolio>
  },
  {
    path: '/contact',
    element: <Contact></Contact>
  },
  {
    path:'/details/:id',
    element:<Details></Details>
  },
  {
    path:'/myblog',
    element:<MyBlog></MyBlog>
  },
  {
    path: '*',
    element: <h1>Opps! this page not found</h1>
  }
]);
export default router